import React, {useContext} from 'react';
import { Context } from './Context';
import Minesweeper from './dom_games/Minesweeper';
import Tetris from './dom_games/Tetris';

const GameRadio = () => {
    const { domGame, handleRadioSelection } = useContext(Context)
    return (
        <div>                                        
            {domGame==='tetris' && <Tetris />}
            {domGame==='minesweeper' && <Minesweeper />}
            
            <p className="radioHeader">DOM Games</p>
            <div className="radioBtnContainer">
                <div>
                    <label>
                        <input  type="radio" 
                                name="domGame" 
                                value="tetris" 
                                checked={domGame==="tetris"} 
                                onChange={handleRadioSelection} />
                    Tetris</label>
                </div>

                <div>
                    <label>
                        <input  type="radio" 
                                name="domGame" 
                                value="minesweeper" 
                                checked={domGame==="minesweeper"} 
                                onChange={handleRadioSelection} />
                    MineSweeper</label>
                </div>

            </div>	
            <br />
        </div>
    )
}

export default GameRadio;